import { ActionTree } from 'vuex';
import { MapState } from './state';
import { StateInterface } from '../index';
import directionsApi  from '../../apis/directionsApi';
import { DirectionsResponse } from '@/interfaces/directions';

export type lngLat = [ number, number ]

const actions: ActionTree<MapState, StateInterface> = {
    someAction( /*{ commit }, payload  */ ) {
        // a line to prevent linter errors
    },
    async getRouteBetweenPoints(  { commit} , {start, end}:{ start:lngLat , end: lngLat}) {

        const resp = await directionsApi.get<DirectionsResponse>(`${start.join(',')};${end.join(',')}`)
        // console.log( (await resp).data.routes[0].geometry.coordinates)
        console.log( resp.data.routes[0].geometry.coordinates)
        commit ('setDistanceDuration', { 
            distance: resp.data.routes[0].distance,
            duration:resp.data.routes[0].duration,
        })
        //Todo: distancia y duracion
        commit('setRoutePolyline', resp.data.routes[0].geometry.coordinates)
    }   
}



export default actions;